import React, { useEffect, useState } from "react";
import { Platform, ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Row, Table } from "react-native-table-component";
import { AspectRatioToken, ButtonTypeTokens, ButtonWidthTypeToken, FontSizeTokens, ImageSizeTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, LottieSizeTokens, LottieTokens, } from "@voltmoney/schema";
import { Button } from "../../../button/Button";
import { TextInput } from "../../../textInput/TextInput";
import { addCommasToNumber, isPanValid, isPhoneNumberValid, sumObjectValues } from "../../utils";
import { Image } from "../../../image/Image";
import { Lottie } from "../../../lottie/Lottie";
import { generateTableData } from "./utils";
import { RegexConfig } from "../../constants";
let xlsx;
if (Platform.OS === 'web') {
    xlsx = require('json-as-xlsx');
}
const CheckCustomerPortfolioPage = ({ height, getOtpAction, triggerAction, activeScreen, submitOtpAction, clientRefNo, otpRef, reqId, leadId, assetDetails, otpErrorMessage, otpSuccessMessage, otpInputState, otpLimitExceeded = false, metaData: metaData }) => {
    const [phone, setPhone] = useState('');
    const [pan, setPan] = useState('');
    const [_otp, setOtp] = useState('');
    const [isGetOtpBtnActive, setGetOtpBtnActive] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [screen, setScreen] = useState("PHONE_PAN_SCREEN" /* CHECK_CUSTOMER_PORTFOLIO_SCREEN_TYPE.PHONE_PAN_SCREEN */);
    const [_clientRefNo, setClientRefNo] = useState(clientRefNo);
    const [_otpRef, setOtpRef] = useState(otpRef);
    const [_reqId, setReqId] = useState(reqId);
    const [_leadId, setLeadId] = useState(leadId);
    const [_assetDetails, setAssetDetails] = useState(assetDetails);
    const [_assetDetailsTableData, setAssetDetailsTableData] = useState(generateTableData(assetDetails));
    const [_otpErrorMessage, setOtpErrorMessage] = useState('');
    const [_otpSuccessMessage, setOtpSuccessMessage] = useState('');
    const [_otpInputState, setOtpInputState] = useState(InputStateToken.DEFAULT);
    const [_otpLimitExceeded, setOtpLimitExceeded] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    useEffect(() => {
        setOtpErrorMessage(otpErrorMessage);
    }, [otpErrorMessage]);
    useEffect(() => {
        setOtpSuccessMessage(otpSuccessMessage);
    }, [otpSuccessMessage]);
    useEffect(() => {
        console.log("otpInputState 2233: ", otpInputState);
        setOtpInputState(otpInputState);
    }, [otpInputState]);
    useEffect(() => {
        setOtpLimitExceeded(otpLimitExceeded);
        if (otpLimitExceeded) {
            setOtp('');
        }
    }, [otpLimitExceeded]);
    //useEffect to update table data.
    useEffect(() => {
        setAssetDetails(assetDetails);
        setAssetDetailsTableData(generateTableData(assetDetails));
    }, [assetDetails]);
    //useEffect to verify validity of the pan and phone
    useEffect(() => {
        if (isPanValid(pan) && isPhoneNumberValid(phone)) {
            setGetOtpBtnActive(true);
        }
        else {
            setGetOtpBtnActive(false);
        }
    }, [pan, phone]);
    useEffect(() => {
        setClientRefNo(clientRefNo);
        setOtpRef(otpRef);
        setReqId(reqId);
        setLeadId(leadId);
    }, [clientRefNo, otpRef, reqId, leadId]);
    //check of otp input length is 6
    useEffect(() => {
        if (_otp.length === 6) {
            submitOtpAction &&
                triggerAction({
                    ...submitOtpAction,
                    payload: {
                        otp: _otp,
                        leadId: _leadId,
                        isResend: false,
                        reqId: _reqId,
                        otpRef: _otpRef,
                        clientRefNo: _clientRefNo,
                        ...submitOtpAction.payload,
                    }
                });
        }
    }, [_otp]);
    useEffect(() => {
        if (activeScreen) {
            setScreen(activeScreen);
        }
    }, [activeScreen]);
    const downloadExcel = () => {
        setDownloadLoading(true);
        const columnData = [
            { label: "SR NO.", value: "sl_no" },
            { label: "Scheme name", value: "schemeName" },
            { label: "Fund type", value: "fundType" },
            { label: "Total value", value: "totalValue" },
            { label: "ISIN", value: "isin" },
            { label: "Folio number", value: "folioNumber" },
            { label: "NAV", value: "nav" },
            { label: "AMC name", value: "amcName" },
            { label: "RTA code", value: "rtaCode" },
            { label: "Available credit limit", value: "creditLimit" },
            { label: "Non eligible reason", value: "blockedReason" },
        ];
        const contentData = [];
        _assetDetailsTableData.map((funds, index) => {
            contentData.push({
                sl_no: `${index + 1}`,
                schemeName: `${funds?.schemeName}`,
                fundType: `${funds?.fundType}`,
                totalValue: `${funds?.totalValue}`,
                isin: `${funds?.isin}`,
                folioNumber: `${funds?.folioNumber}`,
                nav: `${funds?.nav}`,
                amcName: `${funds?.amcName}`,
                rtaCode: `${funds?.rtaCode}`,
                creditLimit: `${funds?.creditLimit}`,
                blockedReason: `${funds?.blockedReason ? funds?.blockedReason : ''}`,
            });
        });
        const _u_data = JSON.parse(localStorage.getItem('u_data'));
        const { phoneNumber } = _u_data;
        let data = [
            {
                sheet: "Customer portfolio details",
                columns: columnData,
                content: contentData
            },
        ];
        let settings = {
            fileName: `customer_portfolio_${phoneNumber}`,
            extraLength: 3,
            writeMode: "writeFile",
            writeOptions: {},
            RTL: false, // Display the columns from right-to-left (the default value is false)
        };
        if (Platform.OS === 'web') {
            xlsx(data, settings); // Will download the excel file
            setDownloadLoading(false);
        }
    };
    const getOtp = async (isResend) => {
        setBtnLoading(true);
        getOtpAction &&
            await triggerAction({
                ...getOtpAction,
                payload: {
                    pan: pan,
                    phone: phone,
                    isResend: isResend ? isResend : false,
                    ...getOtpAction.payload,
                }
            });
        setBtnLoading(false);
    };
    const resetPage = () => {
        setOtpInputState(InputStateToken.DEFAULT);
        localStorage.removeItem('leadData');
        setScreen("PHONE_PAN_SCREEN" /* CHECK_CUSTOMER_PORTFOLIO_SCREEN_TYPE.PHONE_PAN_SCREEN */);
        // setAssetDetails(undefined);
    };
    const renderPhonePan = () => {
        return (React.createElement(View, { style: {
                maxWidth: 450,
                padding: 32,
                borderRadius: 8,
                borderWidth: 1,
                borderColor: 'var(--grey-chalk, #E4E7EC)',
                backgroundColor: '#FFF',
                shadowOffset: { width: 0, height: 3 },
                shadowRadius: 12,
                shadowOpacity: 0.1,
                elevation: 3, // For Android shadow
            } },
            React.createElement(Text, { style: {
                    fontFamily: 'Poppins',
                    fontSize: 16,
                    fontWeight: '600',
                    lineHeight: 20
                } }, 'Enter details linked with mutual fund investments'),
            React.createElement(View, { style: { height: 16 } }),
            React.createElement(TextInput, { onlyNumeric: true, isFocus: false, regex: RegexConfig.MOBILE, type: InputTypeToken.MOBILE, state: InputStateToken.DEFAULT, charLimit: 10, keyboardType: KeyboardTypeToken.numberPad, title: 'Enter phone number', value: phone, placeholder: 'Enter phone number', onChangeText: (value) => {
                    setPhone(value);
                }, metaData: {
                    platform: {
                        OS: 'WEB',
                        Version: '0.10.2',
                    },
                    widgetId: 'INPUT_EMAIL_1',
                    routeId: 'PARTNER_CHECK_CUSTOMER_PORFOLIO',
                    height: 100,
                    width: 100,
                    heightScreen: 100,
                    widthScreen: 100,
                } }),
            React.createElement(View, { style: { height: 16 } }),
            React.createElement(TextInput, { isFocus: false, title: 'Enter PAN', value: pan, regex: RegexConfig.PAN, placeholder: 'Enter PAN', charLimit: 10, type: InputTypeToken.DEFAULT, state: InputStateToken.DEFAULT, isUpperCase: true, onChangeText: (value) => { setPan(value.toUpperCase()); }, metaData: {
                    platform: {
                        OS: 'WEB',
                        Version: '0.10.2',
                    },
                    widgetId: 'INPUT_EMAIL_2',
                    routeId: 'PARTNER_CHECK_CUSTOMER_PORFOLIO',
                    height: 100,
                    width: 100,
                    heightScreen: 100,
                    widthScreen: 100,
                } }),
            React.createElement(View, { style: { height: 48 } }),
            React.createElement(Button, { type: isGetOtpBtnActive ? ButtonTypeTokens.LargeFilled : ButtonTypeTokens.LargeOutline, width: ButtonWidthTypeToken.FULL, label: 'Get OTP', onPress: () => {
                    getOtp(false)
                        .then(() => {
                        setScreen("OTP_SCREEN" /* CHECK_CUSTOMER_PORTFOLIO_SCREEN_TYPE.OTP_SCREEN */);
                    });
                }, loading: btnLoading })));
    };
    const renderGetOtp = () => {
        return (React.createElement(View, { style: {
                maxWidth: 450,
                padding: 32,
                borderRadius: 8,
                borderWidth: 1,
                borderColor: 'var(--grey-chalk, #E4E7EC)',
                backgroundColor: '#FFF',
                shadowOffset: { width: 0, height: 3 },
                shadowRadius: 12,
                shadowOpacity: 0.1,
                elevation: 3, // For Android shadow
            } },
            React.createElement(Text, { style: {
                    fontFamily: 'Poppins',
                    fontSize: 16,
                    fontWeight: '600',
                    lineHeight: 20
                } }, 'Verify your details'),
            React.createElement(View, { style: { height: 4 } }),
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                } },
                React.createElement(Text, { style: {
                        fontFamily: 'Inter',
                        fontSize: 14,
                        fontWeight: '400',
                        lineHeight: 20,
                        color: '#667085'
                    } }, `OTP send to ${phone}`),
                React.createElement(View, { style: { width: 6 } }),
                React.createElement(TouchableOpacity, { onPress: () => {
                        setScreen("PHONE_PAN_SCREEN" /* CHECK_CUSTOMER_PORTFOLIO_SCREEN_TYPE.PHONE_PAN_SCREEN */);
                    } },
                    React.createElement(Text, { style: {
                            fontFamily: 'Inter',
                            fontSize: 14,
                            fontWeight: '600',
                            lineHeight: 20,
                            color: '#1434CB'
                        } }, 'Edit details'))),
            React.createElement(View, { style: { height: 38 } }),
            React.createElement(TextInput, { title: 'Enter OTP', type: InputTypeToken.OTP, state: _otpInputState, keyboardType: KeyboardTypeToken.numberPad, charLimit: 6, metaData: metaData, onChangeText: (value) => { setOtp(value); }, onPressResend: () => getOtp(true), otpLimitExceeded: otpLimitExceeded, caption: {
                    success: _otpSuccessMessage,
                    error: _otpErrorMessage
                } }),
            React.createElement(View, { style: { height: 48 } })));
    };
    const noPortfolioFound = () => {
        return (React.createElement(View, { style: {
                maxWidth: 450,
                padding: 32,
                borderRadius: 8,
                borderWidth: 1,
                borderColor: 'var(--grey-chalk, #E4E7EC)',
                backgroundColor: '#FFF',
                shadowOffset: { width: 0, height: 3 },
                shadowRadius: 12,
                shadowOpacity: 0.1,
                elevation: 3,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            } },
            React.createElement(Image, { size: ImageSizeTokens.Size_40, width: 114, height: 114, uri: `https://volt-images-alpha.s3.ap-south-1.amazonaws.com/verifying_details_1.svg`, aspectRatio: AspectRatioToken.A1_1 }),
            React.createElement(View, { style: { height: 32 } }),
            React.createElement(Text, { style: {
                    fontFamily: 'Poppins',
                    fontSize: 18,
                    fontWeight: '600',
                    lineHeight: 24
                } }, "No investment found"),
            React.createElement(View, { style: { height: 8 } }),
            React.createElement(Text, { style: {
                    fontFamily: 'Poppins',
                    fontSize: 12,
                    fontWeight: '500',
                    lineHeight: 18
                } }, "Try with another mobile or PAN"),
            React.createElement(View, { style: { height: 32 } }),
            React.createElement(Button, { type: isGetOtpBtnActive ? ButtonTypeTokens.LargeFilled : ButtonTypeTokens.LargeOutline, width: ButtonWidthTypeToken.FULL, label: 'Edit details', onPress: () => { setScreen("PHONE_PAN_SCREEN" /* CHECK_CUSTOMER_PORTFOLIO_SCREEN_TYPE.PHONE_PAN_SCREEN */); } })));
    };
    const renderPortfolioLoading = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(View, { style: {
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center'
                } },
                React.createElement(View, null,
                    React.createElement(Lottie, { uri: LottieTokens.SSOLogin, size: LottieSizeTokens.XXXL })))));
    };
    const renderDataTableScreen = () => {
        const tableHead = ["SR NO.", "SCHEME NAME", "FUND TYPE", "TOTAL VALUE", "ISIN", "FOLIO NO", "NAV", "AMC NAME", "RTA CODE", "AVAILABLE CREDIT LIMIT", "NON ELIGIBLE REASON"];
        const widthArr = [66, 300, 100, 104, 120, 120, 75, 150, 100, 169, 180];
        console.log("_assetDetailsTableData: ", _assetDetailsTableData);
        return (React.createElement(ScrollView, { style: {
                width: '100%'
            } },
            React.createElement(View, { style: styles.tableContainer },
                React.createElement(ScrollView, { horizontal: true },
                    React.createElement(View, null,
                        React.createElement(Table, { borderStyle: {
                                borderColor: "#E4E7EC",
                                borderWidth: 1,
                            } },
                            React.createElement(Row, { data: tableHead, widthArr: widthArr, style: styles.tableHead, textStyle: styles.tableHeadText })),
                        React.createElement(ScrollView, { style: styles.tableDataWrapper },
                            React.createElement(Table, { borderStyle: {
                                    borderColor: "#E4E7EC",
                                    borderWidth: 1,
                                } }, _assetDetailsTableData.map((eachFunds, index) => {
                                const dataRow = [
                                    `${index + 1}`,
                                    `${eachFunds?.schemeName}`,
                                    `${eachFunds?.fundType}`,
                                    `₹${eachFunds?.totalValue ? addCommasToNumber(eachFunds?.totalValue) : 0}`,
                                    `${eachFunds?.isin}`,
                                    `${eachFunds?.folioNumber}`,
                                    `${eachFunds?.nav.toFixed(2)}`,
                                    `${eachFunds?.amcName}`,
                                    `${eachFunds?.rtaCode}`,
                                    `₹${eachFunds?.creditLimit ? addCommasToNumber(eachFunds?.creditLimit) : 0}`,
                                    `${eachFunds?.blockedReason ? eachFunds?.blockedReason : ''}`,
                                ];
                                return (React.createElement(Row, { key: index, data: dataRow, widthArr: widthArr, style: [styles.tableRow,
                                        index % 2 ?
                                            { backgroundColor: "rgb(243, 250, 246)" } :
                                            { backgroundColor: "#ffffff" },
                                    ], textStyle: styles.tableText }));
                            }))))))));
    };
    const ChipCards = (title, value) => {
        return (React.createElement(View, { style: {
                width: 300,
                backgroundColor: '#F9FAFB',
                borderRadius: 4,
                padding: 8,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between'
            } },
            React.createElement(Text, { style: {
                    fontFamily: 'Inter',
                    fontSize: 14,
                    fontWeight: '400',
                    lineHeight: 26,
                    color: '#667085'
                } }, title),
            React.createElement(Text, { style: {
                    fontFamily: 'Inter',
                    fontSize: 14,
                    fontWeight: '600',
                    lineHeight: 26
                } }, value)));
    };
    const renderPortfolioScreen = () => {
        const availableCreditLimit = sumObjectValues(_assetDetails?.overallSummary?.eligibleCreditLimit);
        const totalPortfolio = sumObjectValues(_assetDetails?.overallSummary?.totalFundsSummary);
        return (React.createElement(View, { style: {
                display: 'flex',
                flexDirection: 'column',
                width: '100%'
            } },
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                } },
                React.createElement(View, null,
                    ChipCards(`Total portfolio `, `₹${addCommasToNumber(totalPortfolio)}`),
                    React.createElement(View, { style: { height: 24 } }),
                    ChipCards(`Available credit limit`, `₹${addCommasToNumber(availableCreditLimit)}`)),
                React.createElement(View, { style: {
                        flex: 1,
                        flexDirection: 'row',
                        justifyContent: 'flex-end'
                    } },
                    React.createElement(Button, { type: ButtonTypeTokens.MediumSoftFilled, label: 'Check for new user', width: ButtonWidthTypeToken.CONTENT, height: 40, onPress: () => {
                            resetPage();
                        } }),
                    React.createElement(View, { style: {
                            width: 12
                        } }),
                    React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, label: 'Download portfolio', width: ButtonWidthTypeToken.CONTENT, height: 40, fontSize: FontSizeTokens.SM, onPress: () => downloadExcel(), loading: downloadLoading }))),
            React.createElement(View, null, renderDataTableScreen())));
    };
    const _child = () => {
        switch (screen) {
            case "PORTFOLIO_LOADING" /* CHECK_CUSTOMER_PORTFOLIO_SCREEN_TYPE.PORTFOLIO_LOADING */:
                return renderPortfolioLoading();
                break;
            case "NO_PORTFOLIO_SCREEN" /* CHECK_CUSTOMER_PORTFOLIO_SCREEN_TYPE.NO_PORTFOLIO_SCREEN */:
                return noPortfolioFound();
                break;
            case "OTP_SCREEN" /* CHECK_CUSTOMER_PORTFOLIO_SCREEN_TYPE.OTP_SCREEN */:
                return renderGetOtp();
                break;
            case "DATA_TABLE_SCREEN" /* CHECK_CUSTOMER_PORTFOLIO_SCREEN_TYPE.DATA_TABLE_SCREEN */:
                return renderPortfolioScreen();
                break;
            case "PHONE_PAN_SCREEN" /* CHECK_CUSTOMER_PORTFOLIO_SCREEN_TYPE.PHONE_PAN_SCREEN */:
                return renderPhonePan();
                break;
        }
    };
    const _bodyChild = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%',
                } }, _child())));
    };
    return (React.createElement(View, { style: [
            styles.container,
            { height: height }
        ] },
        React.createElement(View, { style: {
                flex: 1
            } },
            React.createElement(View, { style: [styles.body] }, _bodyChild()))));
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
        height: '100%',
    },
    header: {
        paddingHorizontal: 16,
        paddingTop: 12,
        paddingBottom: 12,
        borderBottomWidth: 1,
        borderBottomColor: '#F1F3F5',
        backgroundColor: '#FFF',
        shadowOffset: { width: 0, height: 1 },
        shadowColor: 'rgba(208, 213, 221, 0.25)',
        shadowOpacity: 1,
        shadowRadius: 6,
        elevation: 1,
        height: 66,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    body: {
        paddingTop: 24,
        paddingHorizontal: 40,
        paddingBottom: 24,
    },
    footer: {
        position: 'absolute',
        bottom: '0',
        zIndex: 99,
        width: '100%',
        // backgroundColor: '#FFF',
        borderWidth: 1,
        borderColor: '#F1F3F5',
        // shadowColor: '#D0D5DD',
        // shadowOffset: { width: 0, height: 1 },
        // shadowOpacity: 0.25,
        // shadowRadius: 6,
        // elevation: 2,
        backgroundColor: 'rgb(255, 255, 255)',
        shadowColor: 'rgba(0, 0, 0, 0.2)',
        shadowOffset: {
            width: 0,
            height: -1,
        },
        shadowOpacity: 0.5,
    },
    groupContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    transactionCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
    },
    transactionTopCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: 2,
    },
    transactionBottomCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: "space-between"
    },
    tableContainer: {
        paddingTop: 30,
        backgroundColor: "#fff"
    },
    tableHead: {
        height: 40,
        backgroundColor: "#F9FAFB",
    },
    tableText: {
        textAlign: "left",
        fontWeight: '400',
        fontSize: 12,
        lineHeight: 18,
        paddingVertical: 12,
        paddingHorizontal: 12
    },
    tableHeadText: {
        textAlign: "left",
        fontWeight: '400',
        fontSize: 12,
        lineHeight: 18,
        color: '#667085',
        padding: 12
    },
    tableDataWrapper: { marginTop: -1 },
    tableRow: {},
});
export default (CheckCustomerPortfolioPage);
